import { Loader } from '@jfs/ui-new'
import { Colors } from '../../util/util'
export const LottieLoader = ({ w = 56, h = 56 }: any) => {
  return (
    <>
      <Loader type={'small'} color={Colors.PRIMARY} />
    </>
  )
}
